<div class="container">


    <div class="col-lg-12 col-md-12 mb-md-4 col-sm-12 mb-sm-4 col-12 ">
        <form [formGroup]="form" (ngSubmit)="aceptar()">

            <div
                [ngClass]="isMobile() ? 'login animate__animated animate__fadeInDown' : 'login animate__animated animate__fadeInRight'">
                <div class="caja mat-elevation-z8">

                    <div class="row">
                        <div class="col-md-12">
                            <div id="loginForm_server_validation" class="alert alert-danger" style="display: none">
                            </div>
                        </div>
                    </div>

                    <div class="formulario-login">
                        <mat-form-field color="accent-darker"  appearance="outline">
                            <mat-label>Usuario</mat-label>
                            <input autocomplete="off" type="text" matInput formControlName="UserName"
                                >
                            <button type="button" matSuffix mat-icon-button 
                                (click)="clearUsername()">
                                <mat-icon color="accent-darker">close</mat-icon>
                            </button>

                            <mat-error *ngIf="!userName.valid && userName.touched">
                                {{ Validaciones.EscribirUsuarioRed }}
                            </mat-error>
                        </mat-form-field>

                    </div>

                    <div class="d-flex justify-content-center align-items-center mb-5">

                        <button style="width: 50%;" mat-flat-button color="accent-darker"
                            [disabled]="form.invalid" tabindex="-1"
                            type="submit">{{Etiquetas.Boton}}</button>

                    </div>

                    <div class="d-flex justify-content-evenly align-items-center pie-caja mt-5">
                        <a class="hyperlink-pie-caja" matTooltip="{{Tooltips.IrALogin}}" (click)="login()">
                            {{Etiquetas.YaEstoyVerificado}}</a>
                      

                    </div>



                </div>


            </div>
        </form>
    </div>


</div>



<!-- <section id="hero" class="d-flex align-items-center justify-content-center verificar-cuenta-div">
    <div class="container">

        <div class="spacer-top">
            
        </div>
        <div class="row align-items-center justify-content-evenly mb-3">
            <div class="col-lg-6 pt-4 pt-lg-0 order-lg-1 order-sm-2 order-xs-2 content"
                [ngClass]="isMobile() ? 'login animate__animated animate__fadeInUp' : 'login animate__animated animate__fadeInLeft'">

                <h4 style="margin-top:3%">{{Etiquetas.LeadText1}}</h4>

                <h1>{{Etiquetas.LeadText2}}</h1>
                <h1 class="lead-bars"> //////////</h1>

            </div>
            <div
                class="col-lg-6 order-lg-2 col-md-12 mb-md-4 order-md-2 col-sm-12 mb-sm-4 order-sm-1 col-12 order-xs-1">
                <form [formGroup]="form" (ngSubmit)="aceptar()">

                    <div
                        [ngClass]="isMobile() ? 'login animate__animated animate__fadeInDown' : 'login animate__animated animate__fadeInRight'">
                        <div class="caja mat-elevation-z8">

                            <div class="row">
                                <div class="col-md-12">
                                    <div id="loginForm_server_validation" class="alert alert-danger"
                                        style="display: none"></div>
                                </div>
                            </div>

                            <div class="bienvenido lead2">

                                <p>
                                    {{Etiquetas.LeadText3}}
                                </p>
                            </div>
                            <div>
                            <p class="bienvenido">
                                {{Etiquetas.LeadText4}}
                            </p>
                        </div>
                            <div class="formulario-login">
                                <mat-form-field color="accent-darker"  appearance="outline">
                                    <mat-label>Correo Electrónico</mat-label>
                                    <input autocomplete="off" type="email" matInput formControlName="UserName"
                                        placeholder="Ejemplo@bayer.com">
                                    <button type="button" matSuffix mat-icon-button 
                                        (click)="clearUsername()">
                                        <mat-icon color="accent-darker">close</mat-icon>
                                    </button>

                                    <mat-error *ngIf="!userName.valid && userName.touched">
                                        {{ Validaciones.EscribirUsuarioRed }}
                                    </mat-error>
                                </mat-form-field>

                            </div>

                            <div class="d-flex justify-content-center align-items-center mb-5">

                                <button style="width: 50%;" mat-flat-button color="accent-darker"
                                    [disabled]="form.invalid" tabindex="-1"
                                    type="submit">{{Etiquetas.Boton}}</button>

                            </div>

                            <div class="d-flex justify-content-evenly align-items-center pie-caja mt-5">
                                <a class="hyperlink-pie-caja" matTooltip="{{Tooltips.IrALogin}}" (click)="login()">
                                    {{Etiquetas.YaEstoyVerificado}}</a>
                                <mat-divider class="mat-divider-login" [vertical]="true"></mat-divider>
                                <a class="hyperlink-pie-caja" href="mailto:{{Etiquetas.MailContacto}}">
                                    {{Etiquetas.Ayuda}}</a>

                            </div>



                        </div>


                    </div>
                </form>
            </div>
        </div>
        <div class="spacer-bottom">
        </div>


    </div>
</section> -->